<template>
    <transition name="dropdown">
        <div v-if="isOpen" :class="dropdownClass">
            <div v-if="hasArrow" class="dropdown__arrow"></div>

            <div ref="dropdownBody" class="dropdown__body">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            arrowPositionX: { type: String, required: true },
            arrowPositionY: { type: String, required: true },
            isOpen: { type: Boolean, default: true },
            bgColor: { type: String, default: 'white' },
            recalculatePosition: { type: Boolean, default: true },
            hasArrow: { type: Boolean, default: true },
        },

        data() {
            return {
                arrowPosition: {},
            }
        },

        computed: {
            dropdownClass() {
                return {
                    dropdown: true,
                    [`dropdown--bg-${this.bgColor}`]: true,
                    [`dropdown--arrow-x-${this.arrowPosition.x}`]: this.hasArrow,
                    [`dropdown--arrow-y-${this.arrowPosition.y}`]: this.hasArrow,
                    [`dropdown--no-arrow`]: !this.hasArrow,
                }
            },
        },

        methods: {
            initializeArrowPosition() {
                this.arrowPosition = {
                    x: this.arrowPositionX,
                    y: this.arrowPositionY,
                }
            },

            calculateArrowPosition() {
                const rekt = this.$el.getBoundingClientRect()

                if (rekt.x + rekt.width > window.innerWidth) {
                    this.arrowPosition.x = 'right'
                }

                if (rekt.y + rekt.height > window.innerHeight) {
                    this.arrowPosition.y = 'bottom'
                } else {
                    this.arrowPosition.y = this.arrowPositionY
                }
            },
        },

        watch: {
            isOpen() {
                this.initializeArrowPosition()
                this.$nextTick(() => {
                    if (this.isOpen && this.recalculatePosition && this.$el.offsetTop) {
                        this.calculateArrowPosition()
                    }
                })
            },
        },

        mounted() {
            this.initializeArrowPosition()
        },
    }
</script>
